// extracted by mini-css-extract-plugin
export default {"alternativeDesign":"XbrYrinaYYdd5Pu7RKT0","optionIconSelected":"Wxifz9X2N8jz_qNJsJnC","optionIcon":"saGU4Rtn5uX85Cab0v72"};